import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from "./Grid";
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
// import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import Search from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as MonthlyMoney from './Saga/MonthlyMoney';
import Draggable from 'react-draggable'; // The default
// import RoomDocComponent from '../Rooms/RoomDocComponent';
import RentMoney from '../RentMoney/Index';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
interface Props {

    get_monthly_money_list: any,

    monthly_money_list: any,
    user_details: any,

}



interface State {
    refresh: boolean,
    // modalsheet: boolean,
    // modal_rent_money: boolean,
    // modal_owner: boolean,
    // tatemono_id: string,
    // room_id: string
    // kashinushi_id: number
    // state types
}

class CustomerList extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            refresh: false,

        }

        this.refresh = this.refresh.bind(this);

        this.props.get_monthly_money_list()
    }





    componentWillMount() {

    }

    refresh() {
        this.setState(prevState => ({
            refresh: !prevState.refresh,
        }));

        console.log(this.state.refresh);

        return
    }



    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"

                >
                    <Card >
                        <CardContent >
                            {this.props.user_details.id ? <Search /> : ""}
                        </CardContent >
                    </Card >

                </div>



                <div className="item-outer col-lg-12"

                >
                    <Card >
                        <CardContent >
                            {this.props.monthly_money_list ? <Grid refresh={this.refresh} /> : ""}
                        </CardContent >
                    </Card >

                </div>

            </div >
        );
    }
};


const mapStateToProps = (state: any) => {
    return {

        monthly_money_list: state.MonthlyMoney.monthly_money_list,
        user_details: state.masterReducer.user_details,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {


        get_monthly_money_list(state: any) {
            dispatch(MonthlyMoney.get_monthly_money_list(state))
        },

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);




